import "core-js/modules/es.array.map";
import "core-js/modules/es.object.entries";
import _slicedToArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      params: []
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var amountJson;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;
                amountJson = Object.entries(data).map(function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 2),
                      totalAmount = _ref2[0],
                      amountsStr = _ref2[1];

                  var amountList = amountsStr ? amountsStr.map(function (a) {
                    return {
                      value: a
                    };
                  }) : [];
                  return {
                    totalAmount: parseInt(totalAmount),
                    amountList: amountList
                  };
                });
                _this.params = amountJson;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};